import LargeTextCallToAction from "./LargeTextCallToAction";

const LargeTextCallToActionWithProps = ({ blok }) => {
  return (
    <LargeTextCallToAction
      title={blok.title}
      body={blok.body}
      ctas={blok.ctas}
      backgroundColor={blok.backgroundColor.value}
      backgroundImage={blok.backgroundImage}
      addVerticalPaddingTop={blok.addVerticalPaddingTop}
      addVerticalPaddingBottom={blok.addVerticalPaddingBottom}
      lightMode={
        blok.backgroundColor.value === "#F3F4F6" ||
        blok.backgroundColor.value === "#F9FAFB" ||
        blok.backgroundColor.value === "#FFFFFF"
      }
    />
  );
};

export default LargeTextCallToActionWithProps;
